import styled from '@emotion/styled'
import React, { ReactNode } from 'react'
import { Box } from '../Box/Box'

export interface PlaceholderProps {
  height: string | number
  width?: string | number
  label?: ReactNode
}

export const Placeholder = ({ width = 'auto', height = 120, label }: PlaceholderProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    width={width}
    height={height}
    style={{
      background: 'rgba(51,51,51,.08)',
      border: '2px solid rgba(51,51,51,.3)',
      color: 'rgba(51,51,51,.5)',
    }}
  >
    {label ? (
      <Box inset="xs">{label}</Box>
    ) : (
      <StyledSVG xmlns="http://www.w3.org/2000/svg">
        <line x1={0} y1={0} x2="100%" y2="100%" />
        <line x1="100%" y1={0} x2={0} y2="100%" />
      </StyledSVG>
    )}
  </Box>
)

const StyledSVG = styled('svg')`
  stroke: rgba(51, 51, 51, 0.1);
  stroke-width: 2px;
  height: 100%;
  width: 100%;
`
